export function createContainer(id = 'view', parentSelector = 'body', style){
    var parent = document.querySelector(parentSelector);
    var container = document.createElement('div');
    container.setAttribute('id',id)
    container.setAttribute('style',style);
    parent.appendChild(container);
    return container; 
}

export function getContainer(selector){
    return document.querySelector(selector);
}

export function clear(selector){
    var selector = selector || 'body';
    var parent = document.querySelector(selector);
    while(parent.firstChild){
        parent.removeChild(parent.lastChild)
    }
}
export function setTitle(title){
    /*
    var selector = selector || 'body';
    var spanTitle = document.createElement('span');
    spanTitle.innerHTML = title;
    var parent = document.querySelector(selector);
    parent.append(spanTitle);
    */
   var titleNode = document.querySelector('#title');
   titleNode.innerHTML = title;
}

export function setDescription(description){
    var descriptionNode = document.querySelector('#description');
    descriptionNode.innerHTML = description;
}

export function clearView(selector){
    var view = document.querySelector(selector);
    if (view) while( view.hasChildNodes()){
        view.removeChild(view.lastChild);
    };   
}

export function addExecButton(selector, handler, text){
    var parent = document.querySelector(selector);
    var button = document.createElement('button');
    button.innerText = text;
    parent.append(button);
    button.addEventListener('click',handler);
}

export function copyDocument(doc1, doc2, selector, replace){
    //doc1.head.append(doc2.head)
    appendChilds(doc1.head, doc2.head.childNodes);
    var parentNode = doc1.querySelector(selector);
    if (replace){
        while( parentNode.hasChildNodes()){
            parentNode.removeChild(parentNode.lastChild);
        };
    }
    doc2.body.childNodes.forEach(node =>{ parentNode.appendChild(node)  })        
}

export function appendChilds(parentNode,nodes){
    var nodes = toArray(nodes);
    if (nodes) nodes.forEach((node,index) =>{
        parentNode.appendChild(node);
    });         
}

export function toArray(param){
    if (!param) return;
    if (param instanceof Array) return Array;
    if (param instanceof NodeList) return nodeListToArray(param);
    return [param];
}

export function nodeListToArray(param){
    if (param instanceof Array) return param;
    var nodes = [];
    if (param instanceof NodeList){
        param.forEach(node =>{ nodes.push(node) });             
    }
    return nodes;
}

export  function insertDoc(component, selector){
    var selector = selector || '#view';
    var doc = component.getDocument();
    copyDocument(document,doc, selector,false);  //copyDocument(doc1, doc2, selector, replace){
}

export function configTest(title, handler, description){
    initTests();
    var init = () =>{
        clearView('#view');
        setTitle(title)
        setDescription(description)
        //createContainer('view','body');
        handler();
    }
    addExecButton('body', init, title )
}

export function createContainers(){
    var title = document.querySelector('')
}

export function initTests(){
    var view = document.querySelector('#view');
    if (!view)     createContainer('view','body','border:1px solid red');
    var title = document.querySelector('#title');
    if (!title) createContainer('title','body');
    var description = document.querySelector('#description');
    if (!description) createContainer('description','body')
}